import { Route, useHistory, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { SecureRoute } from '@okta/okta-react';
import { FC, useLayoutEffect } from 'react';
import useSWR from 'swr';
import { getTenantName } from 'packages/lib/auth';
import { isContractorPath, isInternalPath } from 'packages/lib/auth/is-path';

const TenantPathRedirect: FC<React.PropsWithChildren<unknown>> = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { data: tenant } = useSWR('tenant-name', getTenantName);

  useLayoutEffect(() => {
    const contractorIsOnInternalPath =
      isInternalPath(pathname) && tenant === 'contractor';
    if (contractorIsOnInternalPath) {
      const redirectTo = `/contractor${pathname}${search}`;
      history.replace(redirectTo);
    }
    const internalUserIsOnContractorPath =
      isContractorPath(pathname) && tenant === 'primary';
    if (internalUserIsOnContractorPath) {
      const redirectTo = `${pathname.replace('/contractor', '')}${search}`;
      history.replace(redirectTo);
    }
  }, [tenant, pathname, search, history]);
  return null;
};
const OktaRoute: typeof SecureRoute = (props) => {
  return (
    <>
      <TenantPathRedirect />
      <SecureRoute {...props} />
    </>
  );
};

export const SecureSentryRoute = Sentry.withSentryRouting(OktaRoute);

export const SentryRoute = Sentry.withSentryRouting(Route);
